import useLocation from 'hooks/useLocation';
import { useGet15DayForecastQuery } from 'services/weather/weather.api';
import WeatherCardGrid from '../../components/WeatherCardGrid/WeatherCardGrid';
import { day15WeatherDetails } from './config/day15Forecast.config';
import {
  getDay15ForecastCardTitle,
  getDay15ForecastPageHeading,
} from './utils/day15Forecast.utils';

const Day15Forecast = () => {
  const { locations } = useLocation();
  const effectiveLocation = locations.effectiveLocation;
  const { data: day15Forecast = [], isLoading: loadingDay15Forecast } =
    useGet15DayForecastQuery(effectiveLocation);

  return (
    <WeatherCardGrid
      loading={loadingDay15Forecast}
      pageHeading={getDay15ForecastPageHeading(day15Forecast)}
      forecast={day15Forecast}
      cardDetails={day15WeatherDetails}
      getCardTitle={getDay15ForecastCardTitle}
      getCardKey={(item) => item?.iso8601}
      emptyMessage="No 15-day forecast data available"
    />
  );
};

export default Day15Forecast;
